import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  Select,
  message,
  notification,
} from "antd";
import Datepicker from "../toolbox/DatePicker";
import moment from "moment";
import strings from "../../utils/Localization";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setRerender } from "../../redux/actions/rerenderAction";
import useEvrakNo from "../../hooks/useEvrakNo";
import CurrencyInput, { setFieldsAutoClear } from "../toolbox/CurrencyInput";
import useApi from "../../hooks/useApi";

const { Option } = Select;

const formSize = "middle";

function KasaIslemEkleModal({ visible = false, handleCancel, girisMi = null }) {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [form] = Form.useForm();
  const { kasaId } = useParams();
  const dispatch = useDispatch();
  const { kasaIslemEkleModal } = strings.kasaIslem;
  const { getKasaIslemEvrakNo } = useEvrakNo();
  const api = useApi();

  useEffect(() => {
    form.setFieldsValue({
      girisMi: girisMi,
    });
    getKasaIslemEvrakNo().then((evrakNo) => {
      form.setFieldsValue({ evrakNo: evrakNo });
    });
  }, [girisMi]); // eslint-disable-line react-hooks/exhaustive-deps

  const onFinish = async (values) => {
    try {
      const { evrakNo, aciklama, girisMi, tutar, islemTarihi } = values;
      setFetchLoading(true);
      const response = await api.post("/kasaislem/", {
        KasaId: kasaId,
        EvrakNo: evrakNo,
        Aciklama: aciklama,
        VirmanMi: 0,
        GirisMi: girisMi ? 1 : 0,
        Tutar: tutar,
        IslemTarihi: islemTarihi,
      });
      if (response.status === 200) {
        notification["success"]({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        });
        form.resetFields();
        getKasaIslemEvrakNo().then((evrakNo) => {
          form.setFieldsValue({ evrakNo: evrakNo });
        });
        dispatch(setRerender());
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };
  return (
    <Modal
      title={kasaIslemEkleModal.baslik}
      visible={visible}
      onCancel={handleCancel}
      handleCancel={handleCancel}
      okButtonProps={{
        htmlType: "submit",
        form: "kasaIslemEkleForm",
        size: formSize,
        loading: fetchLoading,
      }}
      cancelButtonProps={{ size: formSize }}
      width="60%"
    >
      <Form
        form={form}
        id="kasaIslemEkleForm"
        size={formSize}
        layout="vertical"
        initialValues={{
          islemTarihi: moment(),
          girisMi: girisMi,
          tutar: 0,
        }}
        onFinish={onFinish}
      >
        <Row gutter={24}>
          <Col flex={1}>
            <Form.Item
              name="islemTarihi"
              label={kasaIslemEkleModal.islemTarihi}
              rules={[{ required: true }]}
            >
              <Datepicker />
            </Form.Item>
            <Form.Item
              name="girisMi"
              label={kasaIslemEkleModal.islemTipi}
              rules={[{ required: true }]}
            >
              <Select>
                <Option value={true} style={{ color: "green" }}>
                  {kasaIslemEkleModal.islemTipiSelect.giris}
                </Option>
                <Option value={false} style={{ color: "red" }}>
                  {kasaIslemEkleModal.islemTipiSelect.cikis}
                </Option>
              </Select>
            </Form.Item>
            <Form.Item label={kasaIslemEkleModal.evrakNo} name="evrakNo">
              <Input />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item
              name="tutar"
              label={kasaIslemEkleModal.tutar}
              rules={[{ required: true }]}
            >
              <CurrencyInput {...setFieldsAutoClear(form, "tutar")} />
            </Form.Item>
            <Form.Item label={kasaIslemEkleModal.aciklama} name="aciklama">
              <Input.TextArea rows={5} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default KasaIslemEkleModal;
